module.exports = (__webpack_require__(17))(32);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/core-js/object/get-prototype-of.js from dll-reference vendor
// module id = 805
// module chunks = 0